import { render, staticRenderFns } from "./RiwayatCustomer.vue?vue&type=template&id=5a1c3b23"
import script from "./RiwayatCustomer.vue?vue&type=script&lang=js"
export * from "./RiwayatCustomer.vue?vue&type=script&lang=js"
import style0 from "./RiwayatCustomer.vue?vue&type=style&index=0&id=5a1c3b23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports